var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightIconDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.00012C13 11.2093 11.2091 13.0001 9 13.0001C6.79086 13.0001 5 11.2093 5 9.00012C5 6.79098 6.79086 5.00012 9 5.00012C11.2091 5.00012 13 6.79098 13 9.00012Z",
    fill: "#3446C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 -2.18562e-08C9.27614 -9.78538e-09 9.5 0.223858 9.5 0.5L9.5 3.5C9.5 3.77614 9.27614 4 9 4C8.72386 4 8.5 3.77614 8.5 3.5L8.5 0.5C8.5 0.223858 8.72386 -3.39271e-08 9 -2.18562e-08Z",
    fill: "#3446C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14C9.27614 14 9.5 14.2239 9.5 14.5L9.5 17.5C9.5 17.7761 9.27614 18 9 18C8.72386 18 8.5 17.7761 8.5 17.5L8.5 14.5C8.5 14.2239 8.72386 14 9 14Z",
    fill: "#3446C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.5C18 9.77614 17.7761 10 17.5 10L14.5 10C14.2239 10 14 9.77614 14 9.5C14 9.22386 14.2239 9 14.5 9L17.5 9C17.7761 9 18 9.22386 18 9.5Z",
    fill: "#3446C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.5C4 9.77614 3.77614 10 3.5 10L0.5 10C0.223858 10 1.95705e-08 9.77614 4.37119e-08 9.5C6.78534e-08 9.22386 0.223858 9 0.5 9L3.5 9C3.77614 9 4 9.22386 4 9.5Z",
    fill: "#3446C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.541 2.63601C15.7362 2.83127 15.7362 3.14785 15.541 3.34312L13.4197 5.46444C13.2244 5.6597 12.9078 5.6597 12.7126 5.46444C12.5173 5.26917 12.5173 4.95259 12.7126 4.75733L14.8339 2.63601C15.0291 2.44075 15.3457 2.44075 15.541 2.63601Z",
    fill: "#3446C6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64156 12.8892C5.83683 13.0844 5.83683 13.401 5.64156 13.5963L3.52024 15.7176C3.32498 15.9129 3.0084 15.9129 2.81314 15.7176C2.61787 15.5223 2.61787 15.2058 2.81314 15.0105L4.93446 12.8892C5.12972 12.6939 5.4463 12.6939 5.64156 12.8892Z",
    fill: "#3446C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1866 15.7176C14.9913 15.9129 14.6747 15.9129 14.4795 15.7176L12.3581 13.5963C12.1629 13.401 12.1629 13.0844 12.3581 12.8892C12.5534 12.6939 12.87 12.6939 13.0652 12.8892L15.1866 15.0105C15.3818 15.2058 15.3818 15.5224 15.1866 15.7176Z",
    fill: "#3446C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28715 5.46444C5.09188 5.6597 4.7753 5.6597 4.58004 5.46444L2.45872 3.34312C2.26346 3.14786 2.26346 2.83127 2.45872 2.63601C2.65398 2.44075 2.97056 2.44075 3.16583 2.63601L5.28715 4.75733C5.48241 4.9526 5.48241 5.26918 5.28715 5.46444Z",
    fill: "#3446C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightIconDesktop);
export default __webpack_public_path__ + "static/media/light-icon-desktop.8e3630cfdc9a67be64e2067ee72474ba.svg";
export { ForwardRef as ReactComponent };